<template>
    <div>
        <div v-if="!loading" class="white-box mt-3">
            <b-overlay :show="duplicateLoading" style="margin: -20px; padding: 20px;">
                <div :key="remountComponent" class="data-group">
                    <M3FormTitle title="Achiziții / cheltuieli" :checked="true"></M3FormTitle>
                    <div class="adauga-asociat mb-5">
                        <div>
                            <div class="flexed-selectors">
                                <div class="currency-selector">
                                    <div class="lei" :class="{ 'selected': selected === 'lei' }" @click="selected = 'lei'">L</div>
                                    <div class="euro" :class="{ 'selected': selected === 'eur' }" @click="selected = 'eur'">€</div>
                                </div>
                                <div class="tva-selector">
                                    <p>Afișează prețurile:</p>
                                    <div class="tva-buttons">
                                        <div class="tva" :class="{ 'selected': selectedTva === 'tva' }" @click="selectedTva = 'tva'">Cu TVA</div>
                                        <div class="no-tva" :class="{ 'selected': selectedTva === 'no-tva' }" @click="selectedTva = 'no-tva'">Fără TVA</div>
                                    </div>
                                </div>
                            </div>
                            <p class="title mt-3">Ți-am prebugetat câteva cheltuieli. Îți recomandăm să le păstrezi :)</p>
                        </div>
                        <a class="add-button" @click="openModal()">
                            <p>Adaugă o achiziție nouă</p>
                            <b-icon-plus-circle-fill font-scale="1.2"></b-icon-plus-circle-fill>
                        </a>
                    </div>
                    <div>
                        <AdaugaAchizitiePopup
                            :achizitiiModal="modalShow"
                            :allData="allData"
                            :edit="editAchizitie"
                            :reset="resetFields"
                            @hideTempModal="modalShow = false"
                            @addOrEditAchizitie="$emit('addOrEditAchizitie'); handlePostEditAcquisition($event)"
                        ></AdaugaAchizitiePopup>
                    </div>
                    <b-form v-if="spendings">
                        <div v-for="(spending, category_id) in spendings" :key="category_id" class="activitate">
                            <div class="header">
                                <span class="title">
                                    <strong>{{ spending.category_no }} {{ spending.category }}</strong>
                                </span>
                                <div class="sum">
                                    <span>{{ getPriceForCategory(spending) }}</span>
                                </div>
                                <img v-if="spending.category_no === 2 && statistics && Number(statistics.cheltuieli_consultanta) > 10" id="warn-sign-3-5" src="@/assets/images/M3/M3Sketch/danger-red.png" class="danger-red category-badge">
                                <b-tooltip v-if="spending.category_no === 2 && statistics && Number(statistics.cheltuieli_consultanta) > 10" target="warn-sign-3-5" triggers="hover">
                                    Valoarea cheltuielilor de consultanță (2.1. + 2.2. + 2.3.) pentru pregătirea și implementarea proiectului nu poate depăși 10% din valoarea eligibilă a proiectului
                                </b-tooltip>
                            </div>
                            <div v-for="(subcategory, subcategory_id) in spending.subcategories" :key="subcategory_id">
                                <div class="item gray">
                                    <span class="title">{{ subcategory.subcategory_no }} {{ subcategory.subcategory }}</span>
                                    <div class="sum">
                                        <span>{{ getPriceForSubcategory(subcategory) }}</span>
                                    </div>
                                    <img v-if="subcategory.subcategory_no === '1.1.' && statistics && Number(statistics.cheltuieli_constructii) > 50" id="warn-sign-4-1" src="@/assets/images/M3/M3Sketch/danger-red.png" class="danger-red">
                                    <b-tooltip v-if="subcategory.subcategory_no === '1.1.' && statistics && Number(statistics.cheltuieli_constructii) > 50" target="warn-sign-4-1" triggers="hover">
                                        Valoarea cheltuielilor pentru (1.1) modernizarea spațiilor de producție/servicii nu poate depăși 50% din valoarea proiectului
                                    </b-tooltip>
                                    <img v-if="subcategory.subcategory_no === '3.2.' && statistics && Number(statistics.active_necorporale) > 20" id="warn-sign-4-3" src="@/assets/images/M3/M3Sketch/danger-red.png" class="danger-red">
                                    <b-tooltip v-if="subcategory.subcategory_no === '3.2.' && statistics && Number(statistics.active_necorporale) > 20" target="warn-sign-4-3" triggers="hover">
                                        Valoarea eligibilă a activelor necorporale (3.2) nu poate depăși 20% din valoarea eligibilă a activelor corporale (3.1.1. + 3.1.2. + 3.1.3.) ce fac obiectul proiectului
                                    </b-tooltip>
                                </div>
                                <div v-for="(acquisition, acquisition_id) in subcategory.acquisitions" :key="acquisition_id" class="flex sub-item" :class="getParentClassByOffer(acquisition.offer_1.id, acquisition.offer_2.id, acquisition.env_contr.id, acquisition.contribution_percentage)">
                                    <div class="icons">
                                        <div :id="'offer1'+subcategory.subcategory_no + acquisition_id" class="offer-icon" :class="getClassByOffer(acquisition.offer_1.id)">
                                            <p>1</p>
                                        </div>
                                        <div :id="'offer2'+subcategory.subcategory_no + acquisition_id" class="offer-icon" :class="getClassByOffer(acquisition.offer_2.id)">
                                            <p>2</p>
                                        </div>
                                        <div v-if="acquisition.contribution_percentage > 0" :id="'offer3'+subcategory.subcategory_no + acquisition_id" class="offer-icon" :class="getClassByOffer(acquisition.env_contr.id)">
                                            <p>A</p>
                                        </div>
                                        <b-tooltip :target="'offer1'+subcategory.subcategory_no + acquisition_id" triggers="hover" placement="top">
                                            Oferta 1
                                            <span v-if="acquisition.offer_1.id">este</span>
                                            <span v-else>nu este</span>
                                            încărcată
                                        </b-tooltip>
                                        <b-tooltip :target="'offer2'+subcategory.subcategory_no + acquisition_id" triggers="hover" placement="top">
                                            Oferta 2
                                            <span v-if="acquisition.offer_2.id">este</span>
                                            <span v-else>nu este</span>
                                            încărcată
                                        </b-tooltip>
                                        <b-tooltip :target="'offer3'+subcategory.subcategory_no + acquisition_id" triggers="hover" placement="top">
                                            Anexa privind contribuția achiziției la obiectivele de mediu
                                            <span v-if="acquisition.env_contr.id">este</span>
                                            <span v-else>nu este</span>
                                            încărcată
                                        </b-tooltip>
                                    </div>
                                    <div class="green" style="display: flex; justify-content: space-between">
                                        <span v-if="acquisition && acquisition.description" class="title" style="max-width: 80%">{{ acquisition.description }}</span>
                                        <span>
                                            <!--                                        <img v-if="acquisition.represent_equipment" src="@/assets/images/M3/M3Sketch/reprezintaEchipament.png" alt="Reprezinta Echipament" title="Cheltuiala reprezintă un echipament și contribuie la criteriul de departajare “ponderea echipamentului tehnologic din valoarea totală a proiectului”" style="width: 24px; height: 24px">-->
                                            <span v-if="acquisition.contribution_percentage > 0" style="margin-left: 20px; margin-top: 2px">
                                                <!--                                            <span style="margin-right: 10px; color: #49cda8; font-weight: 600; vertical-align: sub">{{ Number(acquisition.contribution_percentage).toFixed(0) }}%</span>-->
                                                <img src="@/assets/images/M3/M3Sketch/procentMediu.png" alt="Procent de mediu" title="Contribuția cheltuielii la obiectivele de mediu" style="width: 17px; height: 20px">
                                            </span>
                                            <span v-else style="margin-left: 20px;">
                                                <img src="@/assets/images/M3/M3Sketch/procentMediu0.png" alt="Procent de mediu" title="Contribuția cheltuielii la obiectivele de mediu" style="width: 17px; height: 20px">
                                            </span>
                                            <span style="margin-left: 40px;">
                                                <span :id="'cantitate'+subcategory.subcategory_no + acquisition_id" class="quantity-input">{{ acquisition.cantitate }}</span>
                                                <b-tooltip :target="'cantitate'+subcategory.subcategory_no + acquisition_id" triggers="hover" placement="top">Cantitate: {{ acquisition.cantitate }}</b-tooltip>
                                            </span>
                                        </span>
                                    </div>
                                    <div class="green suma">
                                        <span v-if="acquisition && acquisition.total_cu_tva">{{ getPriceForAcquisition(acquisition) }}</span>
                                    </div>
                                    <div class="green actions">
                                        <b-icon-upload v-if="acquisition.contribution_percentage > 0" :id="'anexa'+subcategory.subcategory_no + acquisition_id" class="upload" @click="pickFile(category_id, spending.category_no, subcategory_id, subcategory.subcategory_no, acquisition_id, acquisition.env_contr.id)"></b-icon-upload>
                                        <b-tooltip :target="'anexa'+subcategory.subcategory_no + acquisition_id" triggers="hover" placement="top">Încarcă anexa privind contribuția achiziției la obiectivele de mediu</b-tooltip>
                                        <b-icon-x v-if="acquisition.contribution_percentage > 0 && acquisition.env_contr.id && acquisition.env_contr.filename" :id="'remove-anexa'+subcategory.subcategory_no + acquisition_id" class="delete" @click="deleteFile(category_id, subcategory_id, acquisition_id, acquisition.env_contr.id)"></b-icon-x>
                                        <b-tooltip :target="'remove-anexa'+subcategory.subcategory_no + acquisition_id" triggers="hover" placement="top">Șterge anexa privind contribuția achiziției la obiectivele de mediu</b-tooltip>
                                        <b-icon-plus-circle-fill :id="'duplicate'+subcategory.subcategory_no + acquisition_id" font-scale="1.2" @click="onDuplicate(category_id, subcategory_id, acquisition_id)"></b-icon-plus-circle-fill>
                                        <b-tooltip :target="'duplicate'+subcategory.subcategory_no + acquisition_id" triggers="hover" placement="top">Duplică achiziția</b-tooltip>
                                        <b-icon-dash-circle-fill :id="'remove'+subcategory.subcategory_no + acquisition_id" font-scale="1.2" @click="onDelete(category_id, subcategory_id, acquisition_id)"></b-icon-dash-circle-fill>
                                        <b-tooltip :target="'remove'+subcategory.subcategory_no + acquisition_id" triggers="hover" placement="top">Șterge achiziția</b-tooltip>
                                        <b-icon-pencil-square :id="'edit'+subcategory.subcategory_no + acquisition_id" font-scale="1.2" @click="onEdit(category_id, subcategory_id, acquisition_id)"></b-icon-pencil-square>
                                        <b-tooltip :target="'edit'+subcategory.subcategory_no + acquisition_id" triggers="hover" placement="top">Editează achiziția</b-tooltip>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr class="mt-3">
                        <div class="green-warn">
                            <p>Atenție!</p><br>
                            <p>În conformitate cu prevederile apelului - solicitantul va prezenta o analiză/ un studiu/ document constatator a ofertelor transmise de furnizor/ importator/ producător prin care se va demonstra contribuția la obiectivele de mediu. Vă recomandăm să realizați acest studiu pentru fiecare achiziție. Descărcați mai jos un model de Anexă / Analiză. După completare, aceasta trebuie salvată in PDF și încărcată în linia achiziției. Nu există un model tip de analiză, astfel aveți posibilitatea să întocmiți documentul după bunul plac. Vă recomandăm să încarcați documentul în fiecare achiziție.</p>
                            <a href="/documents/anexa CM.docx" download>
                                DESCARCĂ MODEL
                            </a>
                        </div>
                        <div class="light-green-warn">
                            <p>Atenție!</p><br>
                            <p>La momentul depunerii cererii de finanțare, <strong>se vor expune la fiecare cheltuială previzionată</strong> aferentă investiției verzi, îndeplinirea de către aceasta a unuia sau mai multor criterii de achiziții verzi. <strong>În mod orientativ</strong>, pentru stabilirea acestora, se vor avea în vedere informațiile publicate pe pagina oficială a Comisiei Europene</p>
                            <a href="https://ec.europa.eu/environment/gpp/eu_gpp_criteria_en.htm" target="_blank">
                                Accesează pagina EU GPP
                            </a>
                        </div>
                    </b-form>
                    <input ref="fileUpload" type="file" style="display:none" @change="uploadFile">
                </div>
            </b-overlay>
        </div>
        <LoadingSpinner v-else class="loadingSpinner"></LoadingSpinner>
    </div>
</template>

<script>
    import Vue from 'vue';
    import M3FormTitle from '../M3FormTitle'
    import AdaugaAchizitiePopup from '../achizitii-cheltuieli/AdaugaAchizitiePopup'
    import LoadingSpinner from '@/common/components/LoadingSpinner'
    import { BForm, BFormInput, BIconPencilSquare, BIconUpload, BIconX, BIconTrash, BIconCheckCircleFill, BFormCheckbox, BIconPlusCircleFill, BIconDashCircleFill, BTooltip, BOverlay} from "bootstrap-vue";
    import draggable from 'vuedraggable'
    import api from '@/helpers/api';
    import axios from '@/helpers/axios';

    export default {
        components: {
            LoadingSpinner,
            BForm,
            BFormInput,
            BIconPencilSquare,
            BIconTrash,
            BIconCheckCircleFill,
            BFormCheckbox,
            BIconPlusCircleFill,
            BIconDashCircleFill,
            M3FormTitle,
            BTooltip,
            AdaugaAchizitiePopup,
            draggable,
            BIconUpload,
            BOverlay,
            BIconX
        },
        props: {
            checkScroll:{
                type:Boolean,
                default:false
            },
        },
        data() {
            return {
                loading: false,
                duplicateLoading: false,
                remountComponent: 0,
                modalShow: false,
                selected: 'lei',
                selectedTva: 'no-tva',
                activeNecorporalePeste20: false,
                editAchizitie: {
                    categoryId: null,
                    subcategoryId: null,
                    acquisitionId: null
                },
                resetFields: true,
                spendings:null,
                processing: false,
                uploadedDocument: {},
                acceptedFiles: [
                    'image/png',
                    'image/jpg',
                    'image/jpeg',
                    'application/pdf'
                ],
                uploaded_document_error: null,
                checkIds: true,
                lastAcquisitionId: 0
            }
        },
        computed:{
            statistics() {
                return this.$store.getters['m3Sketch/indicators']
            },
            allData() {
                return this.$store.getters['m3Sketch/allData']
            }
        },
        watch:{
            modalShow: {
                handler: function() {

                    this.remountComponent++
                },
                deep: false
            },
            allData: {
                handler() {
                    {
                        if(this.allData && this.allData.m3_project && this.allData.m3_project.spendings && this.allData.m3_project.spendings.length){
                            this.spendings =   this.allData.m3_project.spendings;
                            this.lastAcquisitionId = this.allData.m3_project.last_acquisition_id ? this.allData.m3_project.last_acquisition_id : 0;
                            this.calculateSpendingsSums();
                            this.checkAcquisitionIds();
                        }
                    }
                },
                deep: true,
                immediate: true
            },
            statistics: {
                handler() {
                    if(this.statistics){
                        if(this.statistics.nerambursabil.EUR > this.statistics.max_budget)
                            this.$swal({
                                title: '<b>Atenție!</b> Bugetul maxim a fost depășit!',
                                icon: 'warning',
                                confirmButtonText: 'OK',
                                showDenyButton: false,
                            })
                    }
                },
                deep: true
            }
        },
        mounted() {

        },
        methods: {
            getPriceForSubcategory(subcategory) {
                if(this.selected === 'eur') {
                    if(this.selectedTva === 'tva') {
                        return this.formatPrice((Number(subcategory.sum) / 4.946).toFixed(2)) +' €'
                    } else if(this.selectedTva === 'no-tva') {
                        return this.formatPrice((Number(subcategory.sumNoTva) / 4.946).toFixed(2)) +' €'
                    }
                } else if(this.selected === 'lei') {
                    if(this.selectedTva === 'tva') {
                        return this.formatPrice(Number(subcategory.sum).toFixed(2)) +' lei'
                    } else if(this.selectedTva === 'no-tva') {
                        return this.formatPrice(Number(subcategory.sumNoTva).toFixed(2)) +' lei'
                    }
                }
            },
            getPriceForCategory(spending) {
                if(this.selected === 'eur') {
                    if(this.selectedTva === 'tva') {
                        return this.formatPrice((Number(spending.sum) / 4.946).toFixed(2)) +' €'
                    } else if(this.selectedTva === 'no-tva') {
                        return this.formatPrice((Number(spending.sumNoTva) / 4.946).toFixed(2)) +' €'
                    }
                } else if(this.selected === 'lei') {
                    if(this.selectedTva === 'tva') {
                        return this.formatPrice(Number(spending.sum).toFixed(2)) +' lei'
                    } else if(this.selectedTva === 'no-tva') {
                        return this.formatPrice(Number(spending.sumNoTva).toFixed(2)) +' lei'
                    }
                }
            },
            getPriceForAcquisition(acquisition) {
                if(this.selected === 'eur') {
                    if(this.selectedTva === 'tva') {
                        return this.formatPrice((Number(acquisition.total_cu_tva) / 4.946).toFixed(2)) +' €'
                    } else if(this.selectedTva === 'no-tva') {
                        return this.formatPrice((Number(acquisition.total) / 4.946).toFixed(2)) +' €'
                    }
                } else if(this.selected === 'lei') {
                    if(this.selectedTva === 'tva') {
                        return this.formatPrice(Number(acquisition.total_cu_tva).toFixed(2)) +' lei'
                    } else if(this.selectedTva === 'no-tva') {
                        return this.formatPrice(Number(acquisition.total).toFixed(2)) +' lei'
                    }
                }
            },
            handlePostEditAcquisition(event){
                axios.get(api.API_ENDPOINTS.m3company + (JSON.parse(localStorage.getItem('currentM3Company')) ? JSON.parse(localStorage.getItem('currentM3Company')).id : 0) + '/grant-application')
                    .then( (response) => {
                        let m3GrantApplication = response.data;
                        if(m3GrantApplication && m3GrantApplication.plan_achizitii){
                            let spendings = m3GrantApplication.plan_achizitii;
                            spendings.forEach(spending => {
                                if(spending.spendings){
                                    spending.spendings.forEach(acquisition => {
                                        if(event === acquisition.id){
                                            let editedAcquisition = this.getSpendingById(event);
                                            if(editedAcquisition){
                                                acquisition.description = editedAcquisition.description;
                                                acquisition.eligible = editedAcquisition.eligible;
                                                acquisition.neeligible = editedAcquisition.neeligible;
                                                acquisition.total = editedAcquisition.total;
                                                acquisition.total_cu_tva = editedAcquisition.total_cu_tva;
                                                spending.value = 0;
                                                spending.value = spending.spendings.reduce((a, b) => +a + +b.total, 0);

                                                axios.post(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/grant-application',  {plan_achizitii: spendings})
                                            }
                                        }
                                    })
                                }
                            })
                        }
                    })
            },
            getSpendingById(id){
                let response = null;

                this.spendings.forEach(spending => {
                    spending.subcategories.forEach( subcategory => {
                        subcategory.acquisitions.forEach(acquisition => {
                            if(id === acquisition.acquisitionId)
                                response = acquisition;
                        })
                    })
                })

                return response;
            },
            checkAcquisitionIds(){
                if(this.allData && this.allData.m3_project && this.spendings && this.checkIds){
                    let lastId = this.lastAcquisitionId;
                    let changesMade = false;
                    let usedIds = [];
                    let duplicatedAcquisitionIds = [];

                    this.spendings.forEach(spending => {
                        if(spending.subcategories && spending.subcategories.length){
                            spending.subcategories.forEach(subcategory => {
                                subcategory.acquisitions.forEach(acquisition => {
                                    if(acquisition.acquisitionId){
                                        if(acquisition.acquisitionId > lastId){
                                            lastId = acquisition.acquisitionId;
                                            changesMade = true;
                                        }
                                    }
                                    else{
                                        lastId++;
                                        acquisition.acquisitionId = lastId;
                                        changesMade = true;
                                    }
                                    if(usedIds.includes(acquisition.acquisitionId))
                                        duplicatedAcquisitionIds.push(acquisition);
                                    else
                                        usedIds.push(acquisition.acquisitionId);
                                })
                            })
                        }
                    })
                    if(duplicatedAcquisitionIds.length){
                        duplicatedAcquisitionIds.forEach( item => {
                            this.spendings.forEach(spending => {
                                if(spending.subcategories && spending.subcategories.length){
                                    spending.subcategories.forEach(subcategory => {
                                        subcategory.acquisitions.forEach(acquisition => {
                                            if(acquisition === item){
                                                lastId++;
                                                acquisition.acquisitionId = lastId;
                                                changesMade = true;
                                            }
                                        })
                                    })
                                }
                            })
                        })
                    }
                    if(changesMade) {
                        this.checkIds = false;
                        let acquisitionIdData = new FormData;
                        acquisitionIdData.append('last_acquisition_id', lastId)
                        this.lastAcquisitionId = lastId;
                        this.$store.dispatch('m3Sketch/saveAllDataProjectPart', acquisitionIdData)

                        let data = new FormData;
                        data.append('spendings', JSON.stringify(this.spendings))
                        this.$store.dispatch('m3Sketch/saveAllDataProjectPart', data)
                    }
                }
            },
            pickFile(category_id, category_no, subcategory_id, subcategory_no, acquisition_id, env_contr_id) {
                let input = this.$refs.fileUpload;
                input.click()
                this.uploadedDocument = {
                    category_id: category_id,
                    category_no: category_no,
                    subcategory_id: subcategory_id,
                    subcategory_no: subcategory_no,
                    index: acquisition_id,
                    env_contr_id: env_contr_id,
                };
            },
            uploadFile(e) {
                if(e.target.files.length > 0) {
                    if(!this.acceptedFiles.includes(e.target.files[0].type)){
                        this.$toast.error('Fișierele acceptate sunt de tip .pdf, .jpg, .png');
                        this.uploadedDocument = {};
                    }
                    else{
                        this.uploaded_document_error = null;
                        this.loading = true
                        let idCompany = JSON.parse(localStorage.getItem('currentM3Company')).id
                        let form =  new FormData;
                        form.append('spendings', JSON.stringify(this.allData.m3_project.spendings))
                        form.append('env_contr', e.target.files[0]);
                        form.append('env_contr_id', this.uploadedDocument.env_contr_id);
                        form.append('category_no', this.uploadedDocument.category_no)
                        form.append('subcategory_no', this.uploadedDocument.subcategory_no)
                        form.append('index', this.uploadedDocument.index)
                        form.append('location', 'env-contributions');
                        axios.post(api.API_ENDPOINTS.m3company + idCompany + '/project', form, {
                            header: { 'Content-Type': 'multipart/form-data' }
                        }).then(response => {
                            this.$toast.success(response.data);
                            this.$store.dispatch('m3Sketch/initializeAllData');
                            this.remountComponent++
                            this.$forceUpdate();
                            this.$store.dispatch('m3Sketch/initializeAllData');
                        }).catch(xhr => {
                            if (xhr.status === 422) {
                                this.$toast.error(xhr.data.errors.file[0]);
                            }
                        }).finally(() => {
                            this.loading = false
                            this.uploadedDocument = {};
                        });
                    }
                }
            },
            deleteFile(category_id, subcategory_id, acquisition_id, fileId) {
                this.loading = true
                let idCompany = JSON.parse(localStorage.getItem('currentM3Company')).id
                axios.delete(api.API_ENDPOINTS.m3company + idCompany + '/delete/file/env-contributions/' + fileId)
                    .then(() => {
                        let form =  new FormData;
                        this.spendings[category_id].subcategories[subcategory_id].acquisitions[acquisition_id].env_contr = {
                            id: null, filename: null,
                        }
                        form.append('spendings', JSON.stringify(this.spendings))
                        axios.post(api.API_ENDPOINTS.m3company + idCompany + '/project', form, {
                            header: { 'Content-Type': 'multipart/form-data' }
                        }).then(response => {
                            this.$toast.success(response.data);
                            this.$store.dispatch('m3Sketch/initializeAllData');
                        }).catch(xhr => {
                            if (xhr.response.status === 422) {
                                this.$toast.error(xhr.response.data.errors.file[0]);
                            }
                        }).finally(() => {
                            this.loading = false
                            this.uploadedDocument = {};
                        })
                    });
            },
            formatPrice(price) {
                price = price.toString().replace('.', ',');
                var pattern = /(-?\d+)(\d{3})/;
                while (pattern.test(price))
                    price = price.replace(pattern, "$1.$2");
                return price;
            },
            getClassByOffer(offer){
                if(!offer){
                    return 'yellow-triangle-warn'
                } else{
                    return 'green-triangle-warn'
                }
            },
            getParentClassByOffer(offer1, offer2, envContr, contribution){
                if(!offer1 && !offer2 && !envContr){
                    return 'twoOfferMissing'
                } else if((offer1 && offer2 && (!envContr && contribution > 0)) || (!offer1 && offer2 && envContr ) || (offer1 && !offer2 && envContr) || (offer1 && offer2 && (!envContr && contribution > 0)) || (offer1 && !offer2 && !envContr) || (!offer1 && offer2 && !envContr) || (!offer1 && !offer2 && envContr)){
                    return 'oneOfferMissing'
                } else {
                    return ''
                }
            },
            calculateSpendingsSums(){
                if(this.spendings && this.spendings.length){
                    this.spendings.forEach(spending => {
                        let categorySum = 0;
                        let categorySumNoTva = 0;
                        if(spending.subcategories && spending.subcategories.length){
                            spending.subcategories.forEach(subcategory => {
                                let subcategorySum = 0;
                                let subcategorySumNoTva = 0;
                                subcategory.acquisitions.forEach(acquisition => {
                                    subcategorySum += acquisition.total_cu_tva;
                                    subcategorySumNoTva += acquisition.total
                                })
                                categorySum += subcategorySum;
                                categorySumNoTva += subcategorySumNoTva;
                                subcategory.sum = subcategorySum;
                                subcategory.sumNoTva = subcategorySumNoTva;
                            })
                        }
                        spending.sum = categorySum;
                        spending.sumNoTva = categorySumNoTva;
                    })
                }
                this.$store.dispatch('pageLoading/setLoading', false)
            },
            onDuplicate(category_id, subcategory_id, acquisition_id) {
                if(this.processing) {
                    return
                }
                this.duplicateLoading = true
                this.processing = true
                let duplicatedAcquisition = this.spendings[category_id].subcategories[subcategory_id].acquisitions[acquisition_id];
                let newAcquisition = {};
                let lastId = this.lastAcquisitionId;
                lastId++;
                for (let key in duplicatedAcquisition)
                    newAcquisition[key] = duplicatedAcquisition[key];
                newAcquisition.acquisitionId = lastId;

                this.spendings[category_id].subcategories[subcategory_id].acquisitions.push(newAcquisition);

                let data = new FormData;
                data.append('spendings', JSON.stringify(this.spendings))
                data.append('last_acquisition_id', lastId)

                axios.post(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/project', data, {
                    header: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(() => {
                    this.$store.dispatch('m3Sketch/initializeIndicators');
                    this.$store.dispatch('m3Sketch/initializeAllData')
                    this.$toast.success('Cheltuiala / achiziția a fost duplicată');
                    this.$emit("addOrEditAchizitie")
                    this.remountComponent++
                    this.calculateSpendingsSums();
                    Vue.$forceUpdate();
                }).catch((xhr) => {
                    if (xhr.status === 422) {
                        this.errors.record(xhr.responseJSON.errors);
                    }
                }).finally(() => {
                    this.processing = false
                    this.duplicateLoading = false
                })
            },
            onDelete(category_id, subcategory_id, acquisition_id) {
                if(this.processing)
                    return

                this.$swal({
                    title: 'Achiziția va fi eliminată complet din proiect.<br>Ești sigur că vrei să continui?',
                    icon: 'warning',
                    confirmButtonText: 'Confirmă',
                    showDenyButton: true,
                    denyButtonText: 'Anulează'
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.processing = true
                        this.duplicateLoading = true
                        this.editAchizitie.categoryId = null;
                        this.editAchizitie.subcategoryId = null;
                        this.editAchizitie.acquisitionId = null;
                        let deletedAcquisition = this.spendings[category_id].subcategories[subcategory_id].acquisitions[acquisition_id];
                        axios.get(api.API_ENDPOINTS.m3company + (JSON.parse(localStorage.getItem('currentM3Company')) ? JSON.parse(localStorage.getItem('currentM3Company')).id : 0) + '/grant-application')
                            .then( (response) => {
                                let m3GrantApplication = response.data;
                                if(m3GrantApplication && m3GrantApplication.plan_achizitii){
                                    let spendings = m3GrantApplication.plan_achizitii;
                                    spendings.forEach(spending => {
                                        if(spending.spendings){
                                            spending.spendings.forEach(acquisition => {
                                                if(deletedAcquisition.acquisitionId === acquisition.id){
                                                    spending.value -= acquisition.total;
                                                    spending.spendings.splice(spending.spendings.indexOf(acquisition), 1);

                                                    axios.post(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/grant-application',  {plan_achizitii: spendings})
                                                }
                                            })
                                        }
                                    })
                                }
                            })

                        this.spendings[category_id].subcategories[subcategory_id].acquisitions
                            .splice(acquisition_id, 1);

                        let data = new FormData;
                        data.append('spendings', JSON.stringify(this.spendings))

                        this.$store.dispatch('m3Sketch/saveAllDataProjectPart', data)
                            .then(() => {
                                this.$store.dispatch('m3Sketch/initializeIndicators');
                                this.$toast.success('Cheltuiala / achiziția a fost ștearsă');
                                this.$emit("addOrEditAchizitie")
                                this.remountComponent++
                                Vue.$forceUpdate();
                                this.calculateSpendingsSums();
                            }).catch((xhr) => {
                                if (xhr.status === 422) {
                                    this.errors.record(xhr.responseJSON.errors);
                                }
                            }).finally(() => {
                                this.processing = false
                                this.duplicateLoading = false
                            });
                    }
                });
            },
            onEdit(category_id, subcategory_id, acquisition_id) {
                this.editAchizitie.categoryId = category_id;
                this.editAchizitie.subcategoryId = subcategory_id;
                this.editAchizitie.acquisitionId = acquisition_id;
                this.resetFields = false;
                this.modalShow = true;
            },
            openModal() {
                this.resetFields = true;
                this.editAchizitie = {
                    categoryId: null,
                    subcategoryId: null,
                    acquisitionId: null
                };
                this.modalShow = true;
            },
            completeForm(event) {
                if(! event) {
                    this.$emit('formIncomplete')
                }
                else{
                    this.$emit('formComplete')
                }
            },
        }
    }
</script>

<style scoped>
.flexed-selectors{
    display: inline-flex;
    align-items: center;
}
.tva-selector p{
    font-size: 13px;
}
.tva-selector{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-left: 45px;
    gap: 10px;
}
.tva-buttons{
    display: inline-flex;
    align-items: center;
    gap: 10px;
}
.tva-buttons .selected{
    opacity: 1;
}
.tva, .no-tva{
    background: #49cda8;
    color: #fff;
    font-weight: 700;
    font-size: 14px;
    border-radius: 20px;
    opacity: 0.5;
    cursor: pointer;
    padding: 3px 10px;
    text-align: center;
}
.sub-item .icons {
    display: flex;
    align-items: center;
    margin-right: 5px;
    min-width: 90px;
    justify-content: flex-end;
}
.twoOfferMissing .green{
    background: #f7ebe1;
}
.oneOfferMissing .green{
    background: #f9f5de;
}
.offer-icon {
    margin-right: 10px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    float: left;
    position: relative;
    cursor: pointer;
}
.quantity-input {
    color: #000000;
    cursor: help;
    min-width: 25px;
    display: inline-block;
    text-align: right;
}
.offer-icon p {
    text-align: center;
    top: 1px;
    position: absolute;
    margin: 0;
    left: 0;
	right: 0;
    font-size: 12px;
    color: #fff;
}
.yellow-triangle-warn{
    background: #ffa405;
}
.green-triangle-warn{
   background: #49cda8;
}
.loadingSpinner{
    position: static;
}
.loadingSpinner img{
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    margin: auto;
}
.white-box{
    background: #fff;
    padding: 20px;
}
.data-group{
    margin: auto;
    width: 90%;
}
.b-tooltip >>> .tooltip-inner{
    max-width: 200px;
    padding: 4px 10px;
    text-align: center;
    background: #eef2f9;
    color: #676d86;
    border-radius: 0.25rem;
}
.b-tooltip >>> .arrow:before{
    border-width: 0 0.3rem 0.3rem;
    border-bottom-color: #eef2f9;
}
.flex{
    display: flex;
}
.adauga-asociat{
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
}
.adauga-asociat .title{
    font-size: 18px;
    color: #515679;
    font-weight: 300;
}
.activitate{
    margin-top: 30px;
}
.activitate .header{
    background: #e9eaec;
    padding: 15px 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
}
.purple .header{
    background: #e6cfea !important;
}
.purple .sub-item{
    background: #f4e5f7 !important;
}
.activitate .header span{
    color: #515679;
}
.activitate .actions svg:not(:last-child){
    margin-right: 10px;
}
.activitate .actions svg{
    color: #9da1af;
    cursor: pointer;
}
.activitate .actions svg:hover{
    color: #7f838f;
}
.activitate .actions .delete{
    color: #f44455;
    font-size: 19px;
}
.activitate .actions .delete:hover{
    color: #f44455;
}
.sub-item{
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
}
.item{
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
}
.danger-red{
    position: absolute;
    right: -40px;
    top: 0;
    bottom: 0;
    margin: auto 0;
}
.gray{
    background: #f6f7f8;
    width: 100%;
    padding: 8px 30px;
    font-size: 14px;
}
.green, .green-warn, .light-green-warn{
    background: #e1f7f1;
    width: 100%;
    padding: 8px 20px;
    line-height: 18px;
    display: flex;
    align-items: center;
}
.green-warn{
    background: #49cda8;
    padding: 30px 30px 10px 30px;
    display: inline-block;
}
.light-green-warn{
    background: #77d195;
    padding: 30px 30px 10px 30px;
    display: inline-block;
    margin-top: 20px;
}
.green-warn p, .light-green-warn p {
    font-size: 14px;
    color: #fff;
}
.light-green-warn a{
    margin-top: 25px;
}
.green-warn a, .light-green-warn a {
    float: right;
    font-size: 14px;
    color: #fff;
    cursor: pointer;
    font-weight: bold;
    padding: 10px 20px;
    text-decoration: none;
    border: 1px solid #fff;
}
.green-warn a:hover, .light-green-warn a:hover {
    color: #fff;
}
.suma{
    margin: 0 10px;
    max-width: 145px;
    color: #515679;
    font-size: 15px;
    text-align: center;
    width: 100%;
    min-height: 40px;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 10px;
}
.actions{
    width: 100%;
    max-width: 150px;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 40px;
}
.sub-item .title{
    font-size: 14px;
    color: #515679;
}
.sub-item >>> input{
    font-size: 12px !important;
    color: #777e90;
    font-weight: 500;
    line-height: 23px;
    width: 60%;
}
.adauga-asociat{
    margin-top: -20px;
}
.add-button{
    margin-top: 0 !important;
}
.switch-box{
    text-align: right;
    margin-top: 25px;
}
.switch-box >>> input, .switch-box >>> label{
    cursor: pointer;
}
.switch-box >>> label{
    font-size: 14px !important;
    color: #38393c;
    line-height: 1.9 !important;
}
.currency-selector{
    display: flex;
    align-items: center;
}
.lei, .euro{
    background: #49cda8;
    color: #fff;
    font-weight: 700;
    font-size: 23px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 30px;
    opacity: 0.5;
    cursor: pointer;
}
.lei{
    margin-right: 10px;
}
.selected{
    opacity: 1;
}
.button-absolute{
    position: absolute;
    top: 30px;
    right: 130px;
    z-index:3;
}
.sum{
    color: #515679;
    font-size: 14px;
    opacity: 0.5;
}
@media (max-width: 1950px){
	.button-absolute{
		position: absolute;
		top: 30px;
		right: 110px;
		z-index:3;
	}
}
@media (max-width: 1700px){
    .white-box{
        padding: 20px 35px !important;
    }
    .adauga-asociat{
        flex-direction: column;
        align-items: inherit;
    }
    .add-button{
        margin-top: 15px !important;
    }
    .button-absolute{
        position: absolute;
        top: 15px;
        right: 60px;
    }
    .danger-red {
        right: -30px;
    }
}

</style>
